import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const CartCheckout = ({ cartItems }) => {
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const navigate = useNavigate();

  const safe = (v) => (v && v > 0 ? v : 0);

  // ----------------------
  // COLLECTIVE SUMMARY
  // ----------------------
  const totalItems = cartItems.reduce((acc, item) => acc + safe(item.quantity), 0);
  const subtotal = cartItems.reduce(
    (acc, item) => acc + safe(item.price_with_gst) * safe(item.quantity),
    0
  );
  const totalGst = cartItems.reduce((acc, item) => acc + safe(item.gst_amount), 0);
  const totalDelivery = cartItems.reduce((acc, item) => acc + safe(item.delivery_charges), 0);

  const grandTotal = subtotal + totalDelivery - discount;

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (amount) => {
    const val = parseFloat(amount) || 0;
    return selectedCurrency === "USD"
      ? `$${(val / dollarRate).toFixed(2)}`
      : `₹${val.toFixed(2)}`;
  };

  // ----------------------
  // APPLY COUPON
  // ----------------------
  const applyCoupon = async () => {
    if (!couponCode.trim()) {
      Swal.fire("Error", "Please enter a coupon code!", "warning");
      return;
    }

    try {
      const response = await axios.get(`${baseurl}getCouponByCode/${couponCode}`);

      if (response.data.success) {
        const coupon = response.data.data;
        if (subtotal < parseFloat(coupon.min_order_amount)) {
          Swal.fire(
            "Error",
            `This coupon requires minimum order of ₹${coupon.min_order_amount}`,
            "error"
          );
          return;
        }
        setDiscount(parseFloat(coupon.discount_amount));
        setAppliedCoupon(coupon);
        Swal.fire("Success", `Coupon Applied! You saved ₹${coupon.discount_amount}`, "success");
      } else {
        Swal.fire("Error", "Invalid or expired coupon code!", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to apply coupon. Please try again.", "error");
    }
  };

  const removeCoupon = () => {
    setDiscount(0);
    setAppliedCoupon(null);
    setCouponCode("");
    Swal.fire("Removed", "Coupon removed successfully.", "info");
  };

  // ----------------------
  // RENDER
  // ----------------------
  return (
    <div className="card p-3">
      <h5 className="smry text-start">Cart Summary</h5>

      {cartItems.length > 0 ? (
        <>
          {/* <div className="d-flex justify-content-between">
            <div>Total Items:</div>
            <div>{totalItems}</div>
          </div> */}

          <div className="d-flex justify-content-between">
            <div>Subtotal (With GST):</div>
            <div>{convertPrice(subtotal)}</div>
          </div>

          <div className="d-flex justify-content-between">
            <div className="text-start">Total GST: </div>
            <div style={{fontSize: '.78rem'}}>[<i>{convertPrice(totalGst)}</i>]</div>
          </div>

          <div className="d-flex justify-content-between">
            <div>Total Delivery Charges:</div>
            <div  style={{fontSize: '.78rem'}} className="text-success">+ ({convertPrice(totalDelivery)}) </div>
          </div>

          {appliedCoupon && (
            <div className="d-flex justify-content-between text-success mt-2">
              <div>Coupon ({appliedCoupon.coupon_code}) Discount:</div>
              <div>- {convertPrice(discount)}</div>
            </div>
          )}

          <hr />

          <div className="d-flex justify-content-between grndttl">
            <h6><b>Grand Total:</b></h6>
            <h6><b>{convertPrice(grandTotal)}</b></h6>
          </div>

          {/* COUPON INPUT */}
          {!appliedCoupon ? (
            <div className="mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Coupon Code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
              />
              <button className="btn btn-success w-100 mt-2" onClick={applyCoupon}>
                Apply Coupon
              </button>
            </div>
          ) : (
            <div className="mt-3 d-flex justify-content-between">
              <span className="text-success">Coupon Applied!</span>
              <button className="btn btn-danger btn-sm" onClick={removeCoupon}>
                Remove
              </button>
            </div>
          )}

          <button
            className="btn btn-primary w-100 mt-3"
            onClick={() =>
              navigate("/checkout", { state: { cartItems, discount, appliedCoupon } })
            }
          >
            Proceed to Checkout
          </button>
        </>
      ) : (
        <p className="text-center">No items in cart</p>
      )}
    </div>
  );
};

export default CartCheckout;
